import { locale } from "@dhx/ts-diagram";
import { el } from "@dhx/ts-common/dom";
import { getSelect } from "./helpers";
import { Text } from "./Text";

export class Enable extends Text {
	constructor(config, events) {
		super(config, events);

		this._handlers.onSelect = (_, val) => {
			this.setValue(val);
		};
	}
	toVDOM() {
		return el(".edit-section.line-edit", { _key: this._uid }, [
			el(".section-title", this._config.label || ""),

			el(".line-edit-content.line-edit-content--full_width", [
				el(
					".dropup.input_element",
					getSelect(
						this._handlers.onSelect,
						"enable",
						[
							{ id: "true", text: locale.switchOptions.on },
							{ id: "false", text: locale.switchOptions.off },
						],
						this._config.value.toString()
					)
				),
			]),
		]);
	}
}
